module.exports = __webpack_public_path__ + "img/ic-wheat-green.3f9f0196.svg";